export const staffManagementTabsArticle = {
  title: 'Staff Management: Core Tabs',
  slug: 'staff-management-tabs',
  content: `Staff Management: Core Tabs

Navigate core people management workflows.

1) Staff Directory
- View staff profiles and open details.
- Use Add Staff Member to create new profiles.

2) Org Chart
- Visualize reporting lines and departments.

3) Documents
- Store staff-related documents and files.

4) Reviews
- Track performance reviews and outcomes.

5) Analytics
- Review staff metrics and trends.
`,
};
